export default "__VITE_ASSET__WO9AaN7CWe0npjbN_tOosg__"